module.exports = __webpack_public_path__ + "static/flags/GR-aabe87b3f59bba47485b26d738722c15.gif";